import { render, staticRenderFns } from "./CardTarjaEnqueteFechamentoSportv.vue?vue&type=template&id=5c08d4d9&scoped=true"
import script from "./CardTarjaEnqueteFechamentoSportv.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteFechamentoSportv.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteFechamentoSportv.vue?vue&type=style&index=0&id=5c08d4d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c08d4d9",
  null
  
)

export default component.exports